import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import TsrOrderLayout from './layouts/TsrOrderLayout';
import TsrOrderPage from './pages/customer/TsrOrderPage';
import TsrOrderSuccessPage from './pages/customer/TsrOrderSuccessPage';

function TsrOrderRoutes() {
  return (
    <TsrOrderLayout>
      <Routes>
        <Route index element={<TsrOrderPage />} />
        <Route path="success" element={<TsrOrderSuccessPage />} />
        <Route path="*" element={<Navigate to="/tsr-order" replace />} />
      </Routes>
    </TsrOrderLayout>
  );
}

export default TsrOrderRoutes;
